// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vuuPaginationControl{height:var(--vuuPaginationControl-height,auto);padding:0 var(--salt-spacing-100);justify-content:flex-end;align-items:center;display:flex}.vuuPaginationControl .saltButton .saltIcon{display:block!important}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___.toString();
